import FaIcon from './fa-icon'

export default FaIcon
